import React from "react";
import { Typography } from "@mui/material";
import { Trans } from "react-i18next";
import { useFormik } from "formik";
import * as yup from "yup";

import { ReactComponent as BackIcon } from "../../../../assets/img/leftArrow.svg";
import { SelectTags } from "../../../../components/Ui";
import ActionButtons from "../ActionButtons";
import products from "../../../../assets/mock/seeds.json";
import useSeedData from "hooks/useSeedData";

const validationSchema = yup.object({
  products: yup
    .array()
    .min(1, "Vous devez entrer au moins 1 culture")
    .max(4, "Vous ne pouvez pas dépasser 4 cultures")
    .required("Non valide, réessayer"),
});

const SelectProducts = ({ onSubmit, onBack, data: formData }) => {
  const [idError, setIdError] = React.useState(false);
  const [tags, setTags] = React.useState(formData?.products || []);
  const { data: seedData, loading: loadingSeeds } = useSeedData();
  const seeds = seedData
    ? seedData.map((seed) => ({
        name: seed.seedName,
        value: seed.id,
        image: seed.seedLogo,
      }))
    : [];

    console.log(formData)

  const formik = useFormik({
    initialValues: {
      ...{
        products: formData?.products,
      },
    },
    validationSchema,
    onSubmit: (data) => {
      // console.log(tags);
      onSubmit({ products: tags });
    },
  });

  console.log(formik.values);
  console.log(formik.errors);

  return (
    <div className="px-4 sm:px-0">
      <div className="flex flex-col justify-center py-16">
        <div className="relative">
          <div
            className="absolute -left-20 top-1/2 -translate-y-1/2 cursor-pointer"
            onClick={onBack}
          >
            <BackIcon />
          </div>
          <Typography variant="title">
            <Trans>formTitles.selectProducts</Trans>
          </Typography>
        </div>

        <form>
          <div className="mt-12">
            <div className="mb-4">
              <Typography fontSize={20} fontWeight={200}>
                Lequel de ces cultures cultivez-vous?
              </Typography>
              <Typography fontSize={14} fontWeight={200}>
                Sélectionnez au minimum une culture et au maximum 4 cultures
              </Typography>
            </div>

            <div className="bg-white p-8">
              <div>
                {!loadingSeeds && (
                  <SelectTags
                    data={seeds}
                    selected={tags}
                    limit={4}
                    onChange={(val) => {
                      setTags(val);
                      formik.setFieldValue("products", val);
                    }}
                    error={formik.errors.products}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-end mt-20 gap-6">
            <ActionButtons onNextStep={formik.handleSubmit} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default SelectProducts;
